<template>
  <ContentWithImage :src="`${$toKebabCase($route.name)}/${sectionName}`" :ext="ext" :img-width="imgWidth" :imageOrder="imageOrder" :imageOrderSm="imageOrderSm" :imageMargin="imageMargin" :margin="margin">
    <text-container :size="textSize" :alignCenter="alignCenter" :justifyCenter="justifyCenter" :justifyEnd="justifyEnd">
      <template v-if="titleSmaller">
        <h3 class="h2" v-html="$t(`products.${$route.name}.${sectionName}.title`)"/>
      </template>
      <template v-else>
        <h2 :class="[!h2 && 'h1']" v-html="$t(`products.${$route.name}.${sectionName}.title`)"/>
      </template>
      <p v-html="$t(`products.${$route.name}.${sectionName}.text`)"/>
      <text-container v-if="!hideBtn">
        <b-btn v-if="demo" class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`request-demo`)}}
        </b-btn>
        <b-btn v-else-if="training" class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`get-training`)}}
        </b-btn>
        <b-btn v-else class="mt-2" variant="primary" v-scroll-to="{ el: '#request-a-demo', offset: -70 }">
          {{$t(`try-now`)}}
        </b-btn>
      </text-container>
    </text-container>
  </ContentWithImage>
</template>

<script>
import { ContentWithImage } from '@/components/ui'

export default {
  name: 'ProductContentWithImage',
  props: {
    training: {
      type: Boolean,
      default: false
    },
    demo: {
      type: Boolean,
      default: false
    },
    sectionName: {
      type: String,
      required: true
    },
    margin: {
      type: String,
      default: '150px 0'
    },
    textSize: {
      type: String
    },
    h2: {
      type: Boolean,
      default: false
    },
    alignCenter: {
      type: Boolean,
      default: false
    },
    justifyCenter: {
      type: Boolean,
      default: false
    },
    justifyEnd: {
      type: Boolean,
      default: false
    },
    titleSmaller: {
      type: Boolean,
      default: false
    },
    hideBtn: {
      type: Boolean,
      default: false
    },
    imageOrder: {
      type: String,
      default: '1'
    },
    imageOrderSm: {
      type: String,
      default: '1'
    },
    imageMargin: {
      type: String,
      default: 'auto'
    },
    ext: {
      type: String,
      default: 'png'
    },
    imgWidth: {
      type: String,
      required: false,
      default: '100%'
    }
  },
  components: { ContentWithImage }
}
</script>

<style lang="sass" scoped>
button
  min-width: 140px

.image-column:not(.order-md-0) + .text-column
  .text-container
    padding-right: 40px
    +media-breakpoint-down(sm)
      padding-right: 0
</style>



// WEBPACK FOOTER //
// src/components/ui/products/ProductContentWithImage.vue